import React, {FC} from "react";
import {Box} from "@material-ui/core";
import FfairLogoIcon from "./FfairLogoIcon";
import useStyles from "./styles";

type Props = {
  color?: "grey" | "blue";
  ffairNameColor?: string;
};

const PoweredByTitle: FC<Props> = ({color = "grey", ffairNameColor}) => {
  const classes = useStyles({color, ffairNameColor});

  return (
    <Box className={classes.root}>
      <span>Powered by&nbsp;</span>
      <FfairLogoIcon color={color} />
      <span className={classes.boldText}>&nbsp;FFAIR</span>
    </Box>
  );
};

export default PoweredByTitle;
